import {
  ApiCartChangeCartStoreRequestedAction,
  apiCartChangeCartStoreFailed,
  apiCartChangeCartStoreSucceeded
} from '../../../api/cart/changeCartStoreApi';
import { call, put } from 'typed-redux-saga';
import changeCartStoreAction, {
  ChangeCartStoreActionInput,
  ChangeCartStoreActionResult
} from '@spa/lib/actions/cart/changeCartStoreAction';

function* changeCartStoreSaga({
  payload: { actionId: requestedActionId, parentActionId, storeCode }
}: ApiCartChangeCartStoreRequestedAction): Generator {
  try {
    const input: ChangeCartStoreActionInput = { storeCode };
    const { cartId, result }: ChangeCartStoreActionResult = yield* call(
      changeCartStoreAction,
      'changeCartStoreAction',
      input
    );
    yield* put(
      apiCartChangeCartStoreSucceeded({
        cartId,
        parentActionId,
        requestedActionId,
        result
      })
    );
  } catch (e) {
    yield* put(
      apiCartChangeCartStoreFailed({
        parentActionId,
        requestedActionId,
        error: e?.toString() ?? null
      })
    );
  }
}

export default changeCartStoreSaga;
